import { IAddContact, IContactLog, IContactUnsubscribe, ITag } from '@routes/addressbook/models/addressbook-model';
import { ContactType } from '@shared/enums/ContactType';
import { CustomContactFieldType } from '@shared/enums/CustomContactFieldType';
import { FreeTextFormat } from '@shared/enums/FreeTextFormat';

export interface IContact {
    id: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    companyName: string;
    customerNumber: string;
    type: ContactType;
    mailPermission: boolean;
    smsPermission: boolean;
    accountOwnerId: string;
    isActive: boolean;
    canEdit:  boolean;
    isDisabled: boolean;
    tags: IContactTag[];
    contactCustomFields: IContactCustomField[];
}

export interface IContactByUser {
    id: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    companyName: string;
}

export interface IContacts {
    contacts: IContact[];
}

export interface IContactForDropdown {
    id: string;
    text: string;
}

export interface IContactsForDropdown {
    roles: IContactForDropdown[];
}

export interface IContactDetails {
    id: string;
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    title: string;
    type: ContactType;
    genderId: string;
    languageId: string;
    email: string;
    phone: string;
    mobile: string;
    companyName: string;
    companyId: string;
    accountOwnerId: string;
    crmId: string;
    customerNumber: string;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    postalCode: string;
    country: string;
    salutation: string;
    mailPermission: boolean;
    smsPermission: boolean;
    accessCode: string;
    isActive: boolean;
    contactCustomFields: IContactCustomField[];
    contactTags: IContactTag[];
    unsubscribes: IContactUnsubscribe[];
    logs: IContactLog[];
    canEdit: boolean;
    canDelete: boolean;
    groupIds: string[];
}

export interface IContactExportDetail {
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    email: string;
    mobile: string;
    phone: string;
    jobTitle: string;
    companyName: string;
    accountOwner: string;
    languageId: string;
    contactType: ContactType;
    genderId: string;
    salutation: string;
    crmId: string;
    customerNumber: string;
    mailPermission: boolean;
    unsubscribeDate: Date;
    smsPermission: boolean;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    postalCode: string;
    country: string;
    accessCode: string;
    isActive: boolean;
    contactCustomFields: IContactCustomField[];
    contactUnsubscribes: IContactUnsubscribe[];
    contactTags: IContactTag[];
}

export interface IContactExportDetails {
    contacts: IContactExportDetail[];
}

export interface IDeleteContacts {
    ids: string[];
}

export class DeleteContacts implements IDeleteContacts {
    constructor(
        public ids: string[],
    ) { }
}

export interface IEnableContacts {
    ids: string[];
}

export class EnableContacts implements IEnableContacts {
    constructor(
        public ids: string[],
    ) { }
}

export interface ICanAddContact {
    contact: IAddContact;
}

export class CanAddContact implements ICanAddContact {
    constructor(
        public contact: IAddContact,
    ) { }
}

export interface IContactCustomField {
    id: string;
    index: number;
    booleanValue: boolean;
    textValue: string;
    numberValue: number;
    dateTimeValue: Date;
    customFieldType: CustomContactFieldType;
    freeTextFormat: FreeTextFormat;
    translations: IFieldTranslations[];
    availableCustomFieldOptions: ICustomContactFieldOption[];
    contactCustomFieldOptions: ICustomContactFieldOption[];
    contactCustomFieldUsers: ICustomContactFieldUser[];
}

export interface ICustomContactFieldOption {
    id: string;
    index: number;
    translations: IFieldTranslations[];
}

export interface ICustomContactFieldUser {
    userId: string;
}

export interface IFieldTranslations {
    id: string;
    value: string;
    isDefault: boolean;
    languageId: string;
}

export interface IContactTag {
    id: string;
    index: number;
    translations: IFieldTranslations[];
}


